<template>
  <div class="login-container">
    <div class="login-box">
      <h2>登录</h2>
      <div class="form-group">
        <label for="username">用户名</label>
        <input type="text" id="username" v-model="username" placeholder="请输入用户名" />
      </div>
      <div class="form-group">
        <label for="password">密码</label>
        <input type="password" id="password" v-model="password" placeholder="请输入密码" />
      </div>
      <button @click="handleLogin" :disabled="loading">
        {{ loading ? '登录中...' : '登录' }}
      </button>
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: ''
    };
  },
  created() {
    this.checkAutoLogin();
  },
  methods: {
    checkAutoLogin() {
      // 检查 URL 中的 timestamp 参数
      // 兼容 ?timestamp=...#/login 和 #/login?timestamp=...
      let timestamp = this.$route.query.timestamp;
      
      if (!timestamp) {
        // 尝试从 window.location.search 获取（针对 ?timestamp=...#/login 格式）
        const searchParams = new URLSearchParams(window.location.search);
        timestamp = searchParams.get('timestamp');
      }

      if (timestamp) {
        const ts = parseInt(timestamp, 10);
        const now = Date.now();
        // 验证是否在 1 分钟之内 (60000 毫秒)
        if (!isNaN(ts)) {
           if (Math.abs(now - ts) <= 60000) {
              // 验证通过，设置临时 token
              // 注意：这里使用 timestamp 作为临时 token，实际项目中可能需要更安全的验证
              sessionStorage.setItem('token', 'auto-login-' + ts);
              
              // 尝试获取 company_id，如果 URL 路径中有的话
              // 例如 /5/?timestamp=...#/login
              const pathParts = window.location.pathname.split('/');
              // 过滤空字符串
              const cleanParts = pathParts.filter(p => p);
              // 假设最后一个数字部分是 company_id，或者根据项目约定的位置
              // 在之前的逻辑中，window.location.href.split('/')[3] 可能是 company_id
              // 这里简单处理，如果能取到 company_id 就跳转 /id/#/，否则跳转 /
              
              // 复用之前的逻辑，从 href 中尝试提取
              // 如果路径是 /5/，split('/') 可能会得到 ["", "5", ""]
              let companyId = null;
              for (const part of cleanParts) {
                if (!isNaN(parseInt(part)) && part.length < 10) { // 简单判断是不是 id
                    companyId = part;
                    break;
                }
              }

              if (companyId) {
                sessionStorage.setItem('company_id', companyId);
                window.location.href = `${window.location.origin}/${companyId}/#/`;
              } else {
                window.location.href = `${window.location.origin}/#/`;
              }
           } else {
              this.error = '自动登录链接已过期，请重新获取';
              console.warn('Auto login expired. Now:', now, 'Timestamp:', ts, 'Diff:', Math.abs(now - ts));
           }
        }
      }
    },
    async handleLogin() {
      if (!this.username || !this.password) {
        this.error = '请输入用户名和密码';
        return;
      }

      this.loading = true;
      this.error = '';

      try {
        const response = await this.$axios.post('https://company.zkhuishou.com/api/v1/auth/login', {
          username: this.username,
          password: this.password
        });

        if (response.status === 200 && response.data && !response.data.error) {
          const responseData = response.data.data;
          const token = responseData.token;
          const companyId = responseData.company_id;
          
          sessionStorage.setItem('token', token);
          if (companyId) {
             sessionStorage.setItem('company_id', companyId);
          }
          
          if (companyId) {
            window.location.href = `/${companyId}/#/`;
          } else {
            this.$router.push('/');
          }
        } else {
            this.error = response.data.message || '登录失败，请检查用户名或密码';
        }
      } catch (err) {
        console.error('Login error:', err);
        if (err.response && err.response.data && err.response.data.message) {
           this.error = err.response.data.message;
        } else {
           this.error = '登录出错，请稍后重试';
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
  /* Use fixed size if the app is fixed size, but vh works for fullscreen overlay */
}

.login-box {
  width: 400px;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

h2 {
  margin-bottom: 24px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #666;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box; /* Important for padding not to exceed width */
}

input:focus {
  border-color: #409eff;
  outline: none;
}

button {
  width: 100%;
  padding: 12px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
}

button:hover {
  background-color: #66b1ff;
}

button:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.error-message {
  margin-top: 16px;
  color: #f56c6c;
  font-size: 14px;
}
</style>
